<template>
  <JbPlanNew
    :biz-ctg="$config.BIZ_CATEGORY.PATROL"
    @link="linkToList"
  ></JbPlanNew>
</template>

<script>
import JbPlanNew from '@/views/omp/cleaning/plan/components/JbPlanNew.vue'

export default {
  name: 'PatrolPlanList',
  components: {
    JbPlanNew
  },
  computed: {},
  data() {
    return {}
  },
  created() {},
  methods: {
    linkToList() {
      this.$tabs.close({ to: '/omp/patrol/plan/list' })
    }
  }
}
</script>

<style lang="scss" scoped></style>
